# Лёгкий запрос для опроса прогресса обрезки записи: пишет в тот же
# кэш Stream по id, не трогая плеер (playback) и рестримы.
query StreamRecordingTrim($contentId: ID!) {
  content(id: $contentId) {
    id
    stream {
      id
      recordingTrim {
        status
        startSeconds
        endSeconds
        progress
        error {
          code
          message
        }
      }
    }
  }
}
